<template>
  <div class="stars">
    <div class="text-center title">
      <strong>Overall rating</strong>
      <p v-bind:class="{ 'error-text': $parent.validation.starRating }">
        Please select a star rating.
      </p>
    </div>

    <input
      class="star star-1"
      id="star-1"
      type="radio"
      name="stars"
      v-model="$parent.fields.starRating"
      value="1"
      @change="$parent.validation.starRating = null"
      v-on:click="selectStars(1)"
    />
    <label class="star star-1" for="star-1"></label>
    <input
      class="star star-2"
      id="star-2"
      type="radio"
      name="stars"
      v-model="$parent.fields.starRating"
      value="2"
      @change="$parent.validation.starRating = null"
      v-on:click="selectStars(2)"
    />
    <label class="star star-2" for="star-2"></label>
    <input
      class="star star-3"
      id="star-3"
      type="radio"
      name="stars"
      v-model="$parent.fields.starRating"
      value="3"
      @change="$parent.validation.starRating = null"
      v-on:click="selectStars(3)"
    />
    <label class="star star-3" for="star-3"></label>
    <input
      class="star star-4"
      id="star-4"
      type="radio"
      name="stars"
      v-model="$parent.fields.starRating"
      value="4"
      @change="$parent.validation.starRating = null"
      v-on:click="selectStars(4)"
    />
    <label class="star star-4" for="star-4"></label>
    <input
      class="star star-5"
      id="star-5"
      type="radio"
      name="stars"
      v-model="$parent.fields.starRating"
      value="5"
      @change="$parent.validation.starRating = null"
      v-on:click="selectStars(5)"
    />
    <label class="star star-5" for="star-5"></label>
  </div>
</template>

<script>
import mixin from "./mixin";

export default {
  name: "starRating",
  data() {
    return {
      active: false,
    };
  },
  methods: {
    selectStars(starVal) {
      $("input.star.actived").removeClass("actived");
      $("label.star.actived").removeClass("actived");
      for (var i = 1; i <= starVal; i++) {
        $("input.star.star-" + i).addClass("actived");
        $("label.star.star-" + i).addClass("actived");
      }
    },
  },
  mixins: [mixin],
};
</script>

<style lang="scss" scoped>
@import "../../../css/abstracts/path";

div.stars {
  /*padding: 0.9rem 0 1.2rem 0%; */
  padding: 26px 0 13px 0%;
  display: block;
  text-align: center;
  .title {
    padding-bottom: 13px;
    p {
      font-size: 0.9rem;
      font-family: "Plus Jakarta Sans", sans-serif;
      font-weight: 500;
    }
  }
  input.star {
    display: none;
  }
  label.star:before {
    background-image: none !important;
  }
  label.star {
    float: none;
    padding: 1rem;
    margin: 0 !important;
    transition: all 0.2s;
    background-image: url("#{$assets}/images/icon-star.svg");
    background-repeat: no-repeat;
    background-size: 1.4rem;
    background-position: center;
  }
  /*input.star:checked ~ label.star {
        background-image: url('#{$assets}/images/bluestar.svg');
        transition: all .25s;
    }
    input.star-5:checked ~ label.star {
        background-image: url('#{$assets}/images/bluestar.svg');
    } */
  label.star:hover {
    transform: scale(1.3);
  }
  label.star.actived {
    background-image: url("#{$assets}/images/bluestar.svg") !important;
    transition: all 0.25s;
  }
}
</style>
